import React from "react";
import { Card } from "@mantine/core";
import { useGetMerchantChannelBalances } from "../../../../hooks/queries/useMerchantQueries";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";
import mpesaLogo from "../../../../assets/img/mpesalogo.jpg";

export default function MpesaBalanceCard() {
  const { data, isLoading, isError, refetch } = useGetMerchantChannelBalances();

  if (isLoading) {
    return <StatCardSkeleton className="bg-green-50" />;
  }

  if (isError) {
    return (
      <Card className="bg-green-50 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load Mpesa balance."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      icon={
        <img
          src={mpesaLogo}
          alt="Mpesa"
          className="w-4 h-4 object-contain rounded-sm"
        />
      }
      label="Mpesa Balance"
      value={formatKES(data?.mpesa)}
      className="bg-green-50"
    />
  );
}
